module.exports = __webpack_public_path__ + "static/media/upload.b1a58016.svg";